import { Slot } from 'expo-router'
import { useEffect } from 'react'

import { useStore } from '@/models'

// TODO: check if it has finish OnBoarding?
export default function () {
  const store = useStore()

  useEffect(() => {
    store.session.fetchOnboardingQuestions()
  }, [])

  return <Slot />
}
